import React from 'react';
import PropTypes from 'prop-types';
import Module from '@sinclair-digital/sbg-storyline-sdk/lib/storyline/Module';
import ModuleButton from '@sinclair-digital/sbg-storyline-sdk/lib/storyline/ModuleButton';
import MediaSearch, {defaultSearchOptions} from './MediaSearch';
import {F} from 'ramda';

export {defaultSearchOptions};

const MediaRouter = ({appContext}) => {
    const myTargets = appContext.getStations();
    return <MediaSearch myTargets={myTargets} />;
};

MediaRouter.propTypes = {
    appContext: PropTypes.object.isRequired,
};

export default new Module({
    moduleName: 'MediaSearch',
    title: 'Media',
    route: 'media2(/)(:params)',
    paramList: [],
    moduleButtons: [
        ModuleButton({
            buttonType: 'nav',
            checkVisible: F,
            id: 'admin-media-tab',
            location: 'Nav',
            href: '#media2',
            text: 'media2',
        }),
    ],
    module: MediaRouter,
    ...MediaRouter,
});
